/** CSV is parsed locally; mapping is explicit because the source schema is unverified. */
export function parseExpenseCsv(text: string): string[][] {
	if (text.length > 2_000_000) throw new Error("CSV_TOO_LARGE");
	const rows: string[][] = [];
	let row: string[] = [],
		cell = "",
		quoted = false;
	text = text.replace(/^\ufeff/, "");
	for (let i = 0; i < text.length; i++) {
		const c = text[i]!;
		if (quoted) {
			if (c === '"' && text[i + 1] === '"') {
				cell += '"';
				i++;
			} else if (c === '"') quoted = false;
			else cell += c;
		} else if (c === '"' && !cell) quoted = true;
		else if (c === ",") {
			row.push(cell);
			cell = "";
		} else if (c === "\n" || c === "\r") {
			if (c === "\r" && text[i + 1] === "\n") i++;
			row.push(cell);
			if (row.some((x) => x.trim())) rows.push(row);
			row = [];
			cell = "";
		} else cell += c;
	}
	if (quoted) throw new Error("CSV_INVALID");
	row.push(cell);
	if (row.some((x) => x.trim())) rows.push(row);
	if (rows.length > 2001 || rows.some((r) => r.length > 100))
		throw new Error("CSV_TOO_LARGE");
	return rows;
}
export type ExpenseColumnMap = {
	date: number;
	title: number;
	amount: number;
	currency: number | null;
};
export function previewExpenseRows(
	rows: string[][],
	mapping: ExpenseColumnMap,
	fallbackCurrency: "JPY" | "KRW",
) {
	return rows.map((row, index) => {
		const rawDate = (row[mapping.date] ?? "").trim();
		const m = rawDate.match(/^(\d{4})[.\/-](\d{1,2})[.\/-](\d{1,2})\.?$/);
		const date = m
			? `${m[1]}-${m[2]!.padStart(2, "0")}-${m[3]!.padStart(2, "0")}`
			: "";
		const parsedDate = date ? new Date(`${date}T00:00:00Z`) : null;
		const validDate =
			parsedDate &&
			!Number.isNaN(parsedDate.getTime()) &&
			parsedDate.toISOString().slice(0, 10) === date;
		const rawAmount = (row[mapping.amount] ?? "")
			.trim()
			.replace(/[,\s¥￥₩원엔]/g, "");
		const amount = /^\d+$/.test(rawAmount) ? Number(rawAmount) : NaN;
		const rawCurrency =
			mapping.currency === null
				? fallbackCurrency
				: (row[mapping.currency] ?? "").trim().toUpperCase();
		const currency: "JPY" | "KRW" | null = /^(JPY|엔|¥|￥)$/.test(rawCurrency)
			? "JPY"
			: /^(KRW|원|₩)$/.test(rawCurrency)
				? "KRW"
				: null;
		const title = (row[mapping.title] ?? "").trim();
		const error = !validDate
			? "날짜를 확인해 주세요"
			: !title || title.length > 80
				? "내용을 확인해 주세요"
				: !Number.isSafeInteger(amount) || amount < 1 || amount > 1_000_000_000
					? "금액을 확인해 주세요"
					: !currency
						? "통화를 확인해 주세요"
						: "";
		return { index: index + 2, date, title, amount, currency, error };
	});
}
